import { TextInput } from "react-admin";
import { IdType } from "utils/constants";
import { useWatch } from "react-hook-form";
import { nineDigits, noCyrillic, onlyDigits, pidValidator } from "utils/validations";

const PersonIdInput = ({ isDisable, userData }) => {
  const currentType = useWatch({ name: "candidateInfo.personIdType" });

  const validators = [];

  validators.push(noCyrillic());

  if (currentType === IdType.PNF) {
    validators.push(onlyDigits);
    validators.push(nineDigits);
  }
  if (currentType === IdType.PID) {
    validators.push(pidValidator());
  }
  return (
    <TextInput
      source="candidateInfo.personId"
      label={"ЛНЧ/ПИД"}
      disabled={false}
      defaultValue={userData?.candidateInfo?.personId || ""}
      validate={validators}
      readOnly={isDisable}
      fullWidth
    />
  );
};

export default PersonIdInput;
